import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Profile } from 'src/app/model/profile.model';
import { ROUTES } from 'src/app/route/routes';
import { HomeService } from 'src/app/service/home.service';
import { MyPDFDownloader } from 'src/app/constants/download-pdf';
import { UserService } from 'src/app/service/user.service';
import { Event } from 'src/app/model/event.model';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { Slot } from 'src/app/model/slot.model';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { LANGUAGES } from 'src/app/constants/lang';
import { Subject } from 'rxjs';
import { FluxService } from 'src/app/service/flux-service';

@Component({
  selector: 'app-complete-booking',
  templateUrl: './complete-booking.component.html',
  styleUrls: ['./complete-booking.component.scss'],
  standalone: false
})
export class CompleteBookingComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  outcomeTitle: string;
  errorMessage: string;

  event_date: string;
  event_time: string;
  private event_ticket_datetime: string;
  private event_ticket_file_name: string;
  profiles: Array<Profile>;
  ticket_profiles: Array<Profile>;
  number_of_users?: number;
  users_in_wl?: Array<string>;

  isSuccess: boolean = false;
  isMassive: boolean = false;
  eventObject: Event | undefined;
  // event_location: string;

  private pdfDownloader: MyPDFDownloader = new MyPDFDownloader();

  userLanguage: string;
  public languages = LANGUAGES;
  convertTime = Slot.convertTime;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private homeService: HomeService,
    public userService: UserService,
    private spinner: SpinnerService,
    private fluxService: FluxService
  ) {}

  ngOnInit() {
    this.userLanguage = this.userService.lang;
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.userLanguage = event.lang;
    });
    this.fluxService.initializeFromRoute(this.route);
    this.outcomeTitle = 'summary.confirm_err';
    this.errorMessage = 'summary.errorMessage';

    let newReservationsObject = this.homeService.getNewReservationsObject();
    if (newReservationsObject && newReservationsObject.uuid_event_occurrence) {
      this.outcomeTitle = 'summary.confirm';
      this.isSuccess = true;
      this.populateFields();
    } else {
      let message = this.homeService.getErrorMessage();
      if (message) this.errorMessage = message;
    }

    this.showPage();

    if (this.userService.isEmployeeWithoutPassenger()) {
      this.isMassive = true;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private populateFields() {
    this.eventObject = this.homeService.getEventObject();

    let slotObject = this.homeService.getSlotObject();
    if (slotObject) {
      this.event_date = slotObject.displayDateTime;
      this.event_time = slotObject.occurrence_start_time;
      this.event_ticket_datetime = slotObject.ticketDateTime;
      this.event_ticket_file_name = slotObject.ticket_file_name;
    }

    let profileObject = this.homeService.getProfileObject();
    if (profileObject) {
      this.profiles = profileObject;
    }

    let newReservationsObject = this.homeService.getNewReservationsObject();
    if (newReservationsObject) {
      this.number_of_users = newReservationsObject.number_of_users;
      this.users_in_wl = newReservationsObject.users_in_wl;
    }

    if (this.profiles && this.users_in_wl) {
      // La lista di Profile[] che non sono finiti in lista di attesa
      this.ticket_profiles = this.profiles.filter((reserved_passenger) => {
        return (
          reserved_passenger.uuid_passenger &&
          !this.users_in_wl!.includes(reserved_passenger.uuid_passenger)
        );
      });
    }
  }

  private showPage() {
    this.spinner.hide();
  }

  get successImage() {
    if (this.isSuccess) {
      return '../../../assets/img/check.svg';
    } else {
      return '../../../assets/img/alert.svg';
    }
  }

  downloadTickets() {
    this.pdfDownloader.downloadTickets(
      {
        event_name: this.eventObject!.event_name[this.userLanguage],
        event_datetime: this.event_ticket_datetime,
        event_ticket_file_name: this.event_ticket_file_name,
        event_long_description:
          this.eventObject!.event_long_description[this.userLanguage],
      },
      this.ticket_profiles,
      this.userService.lang!
    );
  }

  goTo(path: string) {
    const currentFlux = this.fluxService.getCurrentFlux();
    switch (path) {
      case 'home':
        this.router.navigate([ROUTES.HOME.path]);
        break;

      case 'event-list':
        this.router.navigate([currentFlux+'/'+ROUTES.EVENT_LIST.path]);
        break;
    }
  }

  termina() {
    if (this.isMassive || this.userService.uuidPassenger) {
      window.opener.focus();
      window.close();
    }
  }
}
